import React, { useState } from "react";
import { ImageSmoothStyled } from "./styled";

const ImageSmooth = ({ src, alt, className, aspectRatio, ...rest }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <ImageSmoothStyled $aspectRatio={aspectRatio}>
      <div className={`img_smooth_wrap ${isLoaded ? "loaded" : ""}`}>
        <img
          className={className}
          src={src}
          alt={alt || ""}
          onLoad={() => setIsLoaded(true)}
          {...rest}
        />
      </div>
    </ImageSmoothStyled>
  );
};

export default ImageSmooth;
